(() => {
  const SELECTOR = '[data-scrolling-text]';
  const MAX_ITEMS = 48;

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const fillGroup = (root, group, seedHTML) => {
    const targetWidth = root.offsetWidth;
    if (!targetWidth || !seedHTML) return;

    group.innerHTML = seedHTML;

    const seeds = Array.from(group.children);
    if (!seeds.length) return;

    while (group.scrollWidth < targetWidth && group.children.length < MAX_ITEMS) {
      seeds.forEach((seed) => {
        if (group.scrollWidth >= targetWidth || group.children.length >= MAX_ITEMS) return;
        group.appendChild(seed.cloneNode(true));
      });
    }
  };

  const syncGroups = (root) => {
    const groups = root.querySelectorAll('.scrolling-text__group');
    if (groups.length < 2) return;

    const seedHTML = root.dataset.scrollingTextSeed;
    if (!seedHTML) return;

    root.classList.add('is-measuring');

    const primary = groups[0];
    fillGroup(root, primary, seedHTML);

    for (let i = 1; i < groups.length; i += 1) {
      groups[i].innerHTML = primary.innerHTML;
    }

    root.classList.remove('is-measuring');
  };

  const init = (root) => {
    if (root.dataset.scrollingTextReady === 'true') return;
    root.dataset.scrollingTextReady = 'true';

    if (prefersReducedMotion()) return;

    const primary = root.querySelector('.scrolling-text__group');
    if (!primary) return;

    root.dataset.scrollingTextSeed = primary.innerHTML;
    syncGroups(root);

    let resizeTimer;
    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => syncGroups(root), 150);
    };

    window.addEventListener('resize', onResize);

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) {
        window.removeEventListener('resize', onResize);
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll(SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach((el) => {
      el.dataset.scrollingTextReady = 'false';
      delete el.dataset.scrollingTextSeed;
      init(el);
    });
  });
})();
